import Vue from 'vue'

export default {
  list (config = {}) {
    return Vue.http.get('/slotting/products', {
      ...config
    })
  },

  get (id, config = {}) {
    return Vue.http.get(`/slotting/products/${id}`, {
      ...config
    })
  },

  getAll (config = {}) {
    return Vue.http.get('/slotting/product_sales', {
      ...config
    })
  },

  getLocations (id, config = {}) {
    return Vue.http.get(`/slotting/products/${id}/locations`, {
      ...config
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/slotting/product.js